export const getSavingsPotCalculatorState = state =>  state.savingsPotCalculator;